import axiosHttp from "./interceptor.service";

export const getTaskActivity = (taskId, params = {}) =>
  axiosHttp.get(`/taskActivity/${taskId}`, { params });
